(() => {
  const language = document.querySelector('[data-winyel-purchase-labels]');
  if (!language) return;
  const text = JSON.parse(language.textContent);
  for (const key of Object.keys(text)) if (typeof text[key] === 'string') text[key] = text[key].replaceAll('&amp;', '&');
  const root = document.querySelector('main [data-wp-product], main [data-wk-page]');
  if (!root) return;
  const kids = root.hasAttribute('data-wk-page');
  const form = root.querySelector(kids ? '.wk-form' : '.wp-product-form');
  if (!form || form.dataset.purchaseLayout) return;
  const offers = [...form.querySelectorAll(kids ? '[name="wk_bundle"]' : '[data-wp-bundle-quantity]')];
  if (!offers.length) return;
  const quantity = form.querySelector('[name="quantity"]');
  const variantSelect = form.querySelector('[data-wp-variant]');
  const variantData = root.querySelector('[data-wp-variants]');
  const variants = variantData ? JSON.parse(variantData.textContent) : [];
  const currency = root.querySelector('[data-wp-money]');
  const format = value => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency: currency ? JSON.parse(currency.textContent) : text.currency}).format(value / 100);
  const widget = document.createElement('div');
  widget.className = 'winyel-purchase-selector';
  const anchor = form.querySelector(kids ? '.wk-modes, [data-wk-bundles]' : '[data-wp-plans], [data-wp-bundles]');
  anchor.before(widget);
  let mode = 'once';
  let chosen = 0;
  let busy = false;
  const make = (tag, className, content) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (content !== undefined) node.textContent = content;
    return node;
  };
  const variant = () => variants.find(item => String(item.id) === variantSelect?.value);
  const planSelect = () => kids ? form.querySelector('[name="selling_plan"]') : form.querySelector('[data-wp-plans="' + variantSelect.value + '"] select');
  const planOptions = () => [...(planSelect()?.options || [])].filter(option => option.value);
  const recurringOnly = text.requiresPlan;
  function card(group, value, title, detail, price, badge, selected, action) {
    const label = make('label', 'winyel-purchase-card');
    const radio = document.createElement('input');
    radio.type = 'radio';radio.name = 'purchase-layout-' + group;radio.value = value;radio.checked = selected;
    const copy = make('span', 'winyel-purchase-copy');
    const heading = make('span', 'winyel-purchase-heading');
    heading.append(make('strong', '', title));
    if (price) heading.append(make('b', '', price));
    copy.append(heading);
    if (detail) copy.append(make('small', '', detail));
    label.append(radio, copy);
    if (badge) label.append(make('span', 'winyel-purchase-badge', badge));
    radio.addEventListener('change', action);
    return label;
  }
  function total() {
    if (mode === 'subscribe') return planSelect()?.selectedOptions[0]?.textContent.split(' — ').pop() || '';
    const offer = offers[chosen];
    return kids ? offer.dataset.total : format(Math.round(variant().price * Number(offer.querySelector('[data-wp-bundle-factor]').dataset.wpBundleFactor)));
  }
  function apply() {
    if (busy) return;
    busy = true;
    const select = planSelect();
    if (kids) {
      const originalMode = form.querySelector('[name="wk_mode"][value="' + (mode === 'subscribe' ? 'subscribe' : 'once') + '"]');
      if (originalMode) originalMode.checked = true;
      offers[chosen].checked = true;
      offers[chosen].dispatchEvent(new Event('change', {bubbles:true}));
    } else {
      if (select) {
        if (mode === 'once') select.value = '';
        else if (!select.value) select.value = planOptions()[0]?.value || '';
        select.dispatchEvent(new Event('change', {bubbles:true}));
      }
      quantity.value = mode === 'subscribe' ? '1' : offers[chosen].dataset.wpBundleQuantity;
      quantity.dispatchEvent(new Event('change', {bubbles:true}));
    }
    busy = false;
    render();
  }
  function render() {
    const focus = widget.contains(document.activeElement) ? {name:document.activeElement.name,value:document.activeElement.value} : null;
    widget.replaceChildren();
    const options = planOptions();
    if (recurringOnly) mode = 'subscribe';
    if (!options.length) mode = 'once';
    const heading = make('p', 'winyel-purchase-title', text.purchase);
    widget.append(heading);
    const modes = make('fieldset', 'winyel-purchase-modes');
    modes.append(make('legend', 'visually-hidden', text.purchase));
    if (!recurringOnly) modes.append(card('mode', 'once', text.once, text.oneDetail, '', '', mode === 'once', () => {mode = 'once';apply();}));
    if (options.length) {
      const basePrice = variant()?.price;
      const maxSaving = basePrice ? Math.max(0,...options.map(option => Math.round((1-Number(option.dataset.price)/basePrice)*100))) : 0;
      const detail = maxSaving > 0 ? text.save.replace('[percent]', maxSaving) + ' · ' + text.subDetail : text.subDetail;
      modes.append(card('mode', 'subscribe', text.subscribe, detail, '', '', mode === 'subscribe', () => {mode = 'subscribe';apply();}));
    }
    widget.append(modes);
    widget.append(make('p', 'winyel-purchase-title', mode === 'subscribe' ? text.schedule : text.supply));
    const supply = make('fieldset', 'winyel-purchase-supply');
    supply.append(make('legend', 'visually-hidden', mode === 'subscribe' ? text.schedule : text.supply));
    if (mode === 'subscribe') {
      options.forEach(option => {
        const name = option.textContent.split(' — ')[0];
        const price = kids ? option.dataset.total : format(Number(option.dataset.price));
        supply.append(card('supply', option.value, name, text.subDetail, price, '', planSelect().value === option.value, () => {planSelect().value = option.value;apply();}));
      });
    } else {
      offers.forEach((offer,index) => {
        const count = kids ? Number(offer.value) : Number(offer.dataset.wpBundleQuantity);
        const price = kids ? offer.dataset.total : format(Math.round(variant().price * Number(offer.querySelector('[data-wp-bundle-factor]').dataset.wpBundleFactor)));
        const original = kids ? offer.closest('label').querySelector('strong').textContent : offer.querySelector('strong').textContent;
        const title = count + ' ' + (count === 1 ? text.unit : text.units);
        let detail = kids ? offer.closest('label').querySelector('small').textContent : original;
        if (!kids && count > 1) detail += ' · ' + format(Math.round(variant().price * Number(offer.querySelector('[data-wp-bundle-factor]').dataset.wpBundleFactor) / count)) + ' ' + text.each;
        supply.append(card('supply', String(count), title, detail, price, index === 1 ? text.popular : index === 2 ? text.value : '', index === chosen, () => {chosen = index;apply();}));
      });
    }
    widget.append(supply);
    const summary = make('div', 'winyel-purchase-summary');
    summary.append(make('span', '', text.selected), make('strong', '', total()));widget.append(summary);
    if (mode === 'subscribe') {
      const link = make('a', 'winyel-purchase-terms', text.terms);link.href = '/policies/subscription-policy';widget.append(link);
    }
    if (focus) [...widget.querySelectorAll('input')].find(input => input.name === focus.name && input.value === focus.value)?.focus({preventScroll:true});
  }
  form.dataset.purchaseLayout = 'true';
  if (recurringOnly || (planSelect()?.value && !kids)) mode = 'subscribe';
  variantSelect?.addEventListener('change', () => {chosen=0;mode=recurringOnly?'subscribe':'once';apply();});
  apply();
})();
